<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2025-01-08 10:30:43
 * @FilePath: src/views/index/header/apps/index.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 -->
<!--
  @Author 22030124/xieyq
  @Date 2023-12-05 17:03:24
  @Description 头部 =》应用
-->
<template>
  <div style="display: flex; align-items: center; gap: 10px">
    <!-- 弹层内容组件 -->
    <li
      v-if="userInfo.department != 'OPC'"
      :class="[`${scope.clsPrefix}_menu_item`]"
      :id="[`${scope.clsPrefix}_menu_item`]"
      @click="togglePopper"
      @mouseleave.stop="showDrop = false"
    >
      <!-- <img
        src="@/assets/imgs/icon/application.png"
        width="16px"
        height="16px"
        alt=""
      /> -->
      <span slot="title"> {{ $t('app.pbcCollection') }} </span>
      <div
        class="el-icon-question"
        style="font-size: 14px; cursor: pointer"
        @mouseenter.stop="showDrop = true"
      ></div>
      <transition name="dropdown">
        <div
          :class="[`${scope.clsPrefix}_dropdown_menu`]"
          v-if="showDrop"
          @click.stop
        >
          <div
            :class="[`${scope.clsPrefix}_dropdown_menu_container`]"
            id="pbcDetailDropdownMenu"
            ref="logoutPopover"
          >
            {{ $t('app.pbcDescription') }}
            <div
              :class="[`${scope.clsPrefix}_dropdown_menu_container_right-btn`]"
              @click="goDetail"
            >
              {{ $t('app.learnMore') }}
            </div>
          </div>
        </div>
      </transition>
    </li>
    <!-- 收起时显示的按钮 -->
    <!-- <img   v-if="!popperShow"
      @click="togglePopper"
      class="toggle-button"
       :src="require('@/assets/icon_app_menu_switch_close.png')"
       alt="Toggle Menu"
       style="width: 48px; height: 48px;position: fixed; bottom: 80px; right: 20px; z-index: 3;"> -->
    <!-- 展开时显示的按钮 -->
    <!-- <img   v-if="popperShow"
      @click="togglePopper"
      class="toggle-button"
       :class="{'slide-in-right': popperShow}"
       :src="require('@/assets/icon_app_menu_switch.png')"
        alt="Toggle Menu"
        style="width: 72px; height: 108px;position: fixed; bottom: 50px; right: 472px; z-index: 3;"> -->
  </div>
</template>

<script>
// 请求应用分类
// import { requestAppGroups } from "@/api/app.js";
import icAppManage from '@/assets/ic_app_manage.png'
import { mapState } from 'vuex'
export default {
  // 组件名称
  name: 'IndexHeaderApps',
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'index-header-apps-popover-con'
      },
      showDrop: false,
      icAppManage: icAppManage
    }
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  watch: {
    popperShow(newVal, oldVal) {
      if (newVal) {
        this.getData()
      }
    }
  },
  // 方法
  methods: {
    goDetail() {
      window.open('/pbc/detail', '_blank')
    },
    /**
     * 切换弹层显示状态
     * @returns {void}
     */
    togglePopper() {
      event.stopPropagation()
      this.$store.commit(
        'app/SET_POPPER_SHOW',
        !this.$store.state.app.popperShow
      )
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'index-header-apps-popover-con';

.#{$class-prefix} {
  &_dropdown_menu_container::before {
    content: '';
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid #fff;
    // box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: -4px;
    left: 57%;
    transform: translateX(-57%);
  }
  &_dropdown_menu {
    position: absolute;
    left: -87.5px;
    top: 32px;
    z-index: 1000;
    cursor: default;
    padding-top: 8px;
    &_container {
      position: relative;
      background: #ffffff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      padding: 20px; /* 根据需要调整 */
      width: 300px;
      height: 176px;
      font-size: 12px;
      color: #333333;
      line-height: 20px;
      // 菜单信息项
      &_right-btn {
        text-align: right;
        cursor: pointer;
        font-size: 12px;
        color: #4a5ff3;
        line-height: 16px;
        margin-top: 16px;
      }
    }
  }
  &_menu_item {
    font-size: 14px;
    color: #333333;
    padding: 0 13px;
    border: 1px solid #4a5ff3;
    background-color: #fff;
    border-radius: 4px;
    font-size: 14px;
    color: #4a5ff3;
    // background-image: linear-gradient(270deg, #4A5FF3 0%, #4E86FF 100%);
    // border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    line-height: 32px;
    height: 32px;
    gap: 6px;
    position: relative;
    &:hover {
      background: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
      color: #ffffff;
      img {
        filter: brightness(20);
      }
    }
  }
}
</style>
